import api from "../_api";

const preRegister = async (context, body) => {
  const result = await api.preRegister(body);
  return result;
};

const preRegisterFinished = async ({ commit }, body) => {
  await api.preRegisterFinished(body);
  commit("DELETE_ME_AUTHENTICATED");
};

const me = async ({ commit }) => {
  const result = await api.me();
  commit("STORE_ME", result);
};

const login = async ({ commit }, body) => {
  const result = await api.login(body);
  commit("STORE_ME_TOKEN", result);
};

const passwordReset = async ({ commit }, body) => {
  const result = await api.passwordReset(body);
  commit("STORE_ME_TOKEN", result);
};

const passwordRecovery = async (context, body) => {
  const result = await api.passwordRecovery(body);
  return result;
};

const logout = async () => {
  var response = await api.logout();
  return response;
};

const meInGfs = async ({ commit }, body) => {
  const result = await api.meInGfs(body);
  commit("STORE_ME_IN_GFS", result);
};

const getFeatures = async () => {
  const result = await api.getFeatures();
  return result;
};

const getActions = async () => {
  const result = await api.getActions();
  return result;
};

const getNotifications = async ({ commit }) => {
  const result = await api.getNotifications();
  commit("STORE_NOTIFICATIONS", result);
};

export default {
  preRegister,
  preRegisterFinished,
  me,
  meInGfs,
  login,
  passwordReset,
  passwordRecovery,
  logout,
  getFeatures,
  getActions,
  getNotifications
};
